import { SignedIn, SignedOut, SignInButton, SignUpButton } from "@clerk/clerk-react";
import { Link } from "react-router-dom";

export function Landing() {
  return (
    <section className="max-w-3xl mx-auto px-6 py-24 text-center">
      <h1 className="font-display text-5xl md:text-6xl font-semibold tracking-tight">
        Tell us about your dream wedding.
      </h1>
      <p className="mt-6 text-lg text-stone-600">
        A photo-real preview of your day, grounded in real vendors you can book.
      </p>

      <div className="mt-10 flex items-center justify-center gap-3">
        <SignedOut>
          <SignUpButton mode="modal">
            <button className="px-5 py-3 rounded-full bg-stone-900 text-stone-50 hover:bg-stone-700 transition">
              Start planning
            </button>
          </SignUpButton>
          <SignInButton mode="modal">
            <button className="px-5 py-3 rounded-full border border-stone-300 hover:bg-stone-100 transition">
              Sign in
            </button>
          </SignInButton>
        </SignedOut>
        <SignedIn>
          <Link
            to="/plan"
            className="px-5 py-3 rounded-full bg-stone-900 text-stone-50 hover:bg-stone-700 transition"
          >
            Continue planning →
          </Link>
        </SignedIn>
      </div>

      <ul className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6 text-left">
        <li>
          <div className="text-xs uppercase tracking-wide text-stone-500 mb-1">1. Describe</div>
          <p className="text-sm text-stone-700">
            Tell our concierge about your day — date, place, vibe, vendors you care about.
          </p>
        </li>
        <li>
          <div className="text-xs uppercase tracking-wide text-stone-500 mb-1">2. See it</div>
          <p className="text-sm text-stone-700">
            We generate a photo-real preview of your wedding, scene by scene — grounded on real local vendors.
          </p>
        </li>
        <li>
          <div className="text-xs uppercase tracking-wide text-stone-500 mb-1">3. Book it</div>
          <p className="text-sm text-stone-700">
            Every element links back to the vendor behind it. Save the ones you like and reach out.
          </p>
        </li>
      </ul>
    </section>
  );
}
